import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { useAuth, hasRole } from '@/lib/auth';
import { WhatsAppSetup } from '@/components/whatsapp/WhatsAppSetup';
import { ConversationList } from '@/components/whatsapp/ConversationList';
import { ConversationThread } from '@/components/whatsapp/ConversationThread';

export default function WhatsAppPage() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const [tick, setTick] = useState(0);
  const selected = params.get('c');
  const canAct = hasRole(user, ['admin', 'tech']);

  return (
    <div className="space-y-6" data-testid="whatsapp-page">
      <div>
        <h1 className="text-2xl font-bold flex items-center gap-2"><MessageCircle className="w-6 h-6 text-emerald-400" />WhatsApp</h1>
        <p className="text-sm text-[hsl(var(--muted-foreground))] mt-1">Conversaciones con pastores e iglesias. El agente IA responde lo sencillo y deja borradores en lo complejo.</p>
      </div>
      <WhatsAppSetup isAdmin={user?.role === 'admin'} />
      <div className="grid lg:grid-cols-[340px_1fr] gap-4 min-h-[560px]">
        <ConversationList selected={selected} onSelect={(id) => setParams({ c: id })} tick={tick} />
        {selected
          ? <ConversationThread key={selected} id={selected} canAct={canAct} onChange={() => setTick((t) => t + 1)} />
          : <div className="rounded-lg border border-dashed border-[hsl(var(--border))] grid place-items-center text-sm text-[hsl(var(--muted-foreground))]" data-testid="whatsapp-no-selection">Elige una conversación</div>}
      </div>
    </div>
  );
}
